// The feature registry (docs/CONTRACTS.md section 16). Frozen: owned by the contracts piece. The shell builds its
// route tree and rail from `features` and renders `Omnibar` once inside the app frame. Order = rail order.
import type { Feature, OmnibarComponent } from './feature.ts'
// The P2 freeze (docs/CONTRACTS.md section 21) added people, pipeline, ask, lists, waves, network, connections, settings
// and notice (/personvern, public and bare) as placeholders, each owned by its P2b piece.
import { feature as today } from './today/routes.tsx'
import { feature as org } from './org/routes.tsx'
import { feature as people } from './people/routes.tsx'
import { feature as pipeline } from './pipeline/routes.tsx'
import { feature as touches } from './touches/routes.tsx'
import { feature as ask } from './ask/routes.tsx'
import { feature as lists } from './lists/routes.tsx'
import { feature as waves } from './waves/routes.tsx'
import { feature as network } from './network/routes.tsx'
import { feature as graph } from './graph/routes.tsx'
import { feature as connections } from './connections/routes.tsx'
import { feature as library } from './library/routes.tsx'
import { feature as settings } from './settings/routes.tsx'
// The P4 freeze (docs/CONTRACTS.md section 22.6) added ideas, marketing and solutions (the rail's later group), the
// owner's weights, Jev review, desk import and enrichment screens, and the agent console, as placeholders, each owned by
// its P4b piece.
import { feature as enrichment } from './enrichment/routes.tsx'
import { feature as marketing } from './marketing/routes.tsx'
import { feature as solutions } from './solutions/routes.tsx'
import { feature as ideas } from './ideas/routes.tsx'
import { feature as weights } from './weights/routes.tsx'
import { feature as jev } from './jev/routes.tsx'
import { feature as agents } from './agents/routes.tsx'
import { feature as desk } from './desk/routes.tsx'
import { feature as admin } from './admin/routes.tsx'
import { feature as notice } from './notice/routes.tsx'
import { feature as auth } from './auth/routes.tsx'
import { feature as omnibar } from './omnibar/routes.tsx'
import { Omnibar as omnibarMount } from './omnibar/mount.tsx'

export const features: readonly Feature[] = [
  today,
  org,
  people,
  pipeline,
  touches,
  ask,
  lists,
  waves,
  network,
  graph,
  connections,
  enrichment,
  library,
  marketing,
  solutions,
  ideas,
  settings,
  weights,
  jev,
  agents,
  desk,
  admin,
  notice,
  auth,
  omnibar,
]
export const Omnibar: OmnibarComponent = omnibarMount
